import React from "react";

function ShowCase(props) {
  const { title, imgSrc, description, bgPrimary } = props;
  return (
    <section
      className={`flex flex-wrap items-center justify-center h-dvh ${
        bgPrimary ? "bg-slate-900 text-white" : "bg-yellow-200 text-black"
      }`}
    >
      <div
        className={`flex justify-center items-center max-w-xl min-w-96 w-1/2 h-1/2 rounded-s-lg ${
          bgPrimary ? "bg-yellow-200 text-black" : "bg-slate-900 text-white"
        }`}
      >
        <img
          src={imgSrc}
          alt={`Showcasing ${title}`}
          className="max-w-sm h-auto rounded-lg"
        />
      </div>
      <div className="p-4 flex flex-col justify-center max-w-xl min-w-96 w-1/2 h-1/2 bg-white rounded-e-xl">
        <h2 className="font-heading text-5xl font-bold">{title}</h2>
        <p className="mt-2">{description}</p>
      </div>
    </section>
  );
}

export default ShowCase;
